export enum HandballTurnoverAttribute {
  Traveling = 470,
  SteppingTheLine = 471,
}
